import type { PropsWithChildren } from "react";

import { Heading } from "@stacklet/ui";

interface Props extends PropsWithChildren {
  /** Section title. */
  title: string;
}

/** A titled block of help copy; the drawer body spaces sibling sections. */
export function HelpSection({ title, children }: Props) {
  return (
    <section className="flex flex-col gap-y-lg">
      <Heading level={3}>{title}</Heading>
      {children}
    </section>
  );
}
